import script from "./THeaderBalanceHelper.vue?vue&type=script&setup=true&lang=ts"
export * from "./THeaderBalanceHelper.vue?vue&type=script&setup=true&lang=ts"

import "./THeaderBalanceHelper.vue?vue&type=style&index=0&id=4661aeb1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4661aeb1"]])

export default __exports__